const CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

export const formatCurrency = (amount: number): string => CURRENCY_FORMATTER.format(amount)
